import React, { useCallback, useContext, useEffect, useRef, useState } from "react";
import { Button, Modal, ModalBody, ModalHeader } from "reactstrap";
import { LOADER_ENUM } from "../../models/LoaderModel";
import LoaderHOC from "../shared/LoaderHOC";
import QuestionsList from "./QuestionsList";
import SendIcon from "../../images/send-icon.svg";
import bulbIcon from "../../images/bulbLight.png";
import bulbDark from "../../images/bulbDark.png";

import ChatIcon from "../../images/chat-icon.svg";
import moment from "moment";
import {
  IConversationModel,
  ISummarizationModel,
} from "../../models/ChatModels";
import ChatLoader from "../../commonfields/ChatLoader";
import { ProjectStatus } from "../../models/ProjectModel"
import ProductionQuestionsList from "./ProductionQuestionList";
import add from '../../images/add.png';
import { ThemeContext } from "../../models/ThemeContext";
import { ThemeTypes } from "../../models/SharedModel";

interface IChatComponentProps {
  conversationList: IConversationModel[];
  question_answer: (prompt: string) => Promise<void>;
  questionsList: string[];
  chatLoader: boolean;
  summarization?: ISummarizationModel;
  textAreaDisable?: boolean;
  notFoundMessage?: string;
  setConversationList?: React.Dispatch<React.SetStateAction<IConversationModel[]>>
  dontScroll?: boolean;
  setDontScroll?: React.Dispatch<React.SetStateAction<boolean>>;
  displayCheck?: boolean;
  project_main?:any;
  croppedImage?: any;
  clearImage?:Function;
  isRecomendationsOptions?:boolean;
  isAddOptions?:boolean
}

const ChatComponent2 = (props: IChatComponentProps) => {
  const {
    conversationList, // chat list
    question_answer, // api to set chat list
    summarization, // summarize the doc
    questionsList, // recommendations list
    chatLoader, // loader
    textAreaDisable, // text disable field
    notFoundMessage, // not found message inpuy
    setConversationList, // change chat list
    dontScroll, // avoid scroll to bottom 
    setDontScroll, // set above
    displayCheck, // display api check box
    project_main,
  } = props;

  const { themeName } = useContext(ThemeContext);

  // states
  const [chatText, setChatText] = useState("");
  const bottomRef = useRef<null | HTMLDivElement>(null);

  const [imageModal, setImageModal] = useState(false);
  const [popImage, setPopImage] = useState();
  


  // helpers
  const handleChatTextChange = (e: any) => {
    setChatText(e?.target?.value);
  };

  const toggleImageModal = () => setImageModal(prev => !prev)

  const promptImageView = (img:any) =>{
    setPopImage(img)
    toggleImageModal()
  }

  const keyDownCheck = (event: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (event.key === "Enter") {
      if (chatText?.trim()?.length > 0) {
        event.preventDefault();
        event.stopPropagation();
        question_answer(chatText);
        setChatText("");
      }
    }
  };

  const handleApiCheck = (e: React.ChangeEvent<HTMLInputElement>, id: string) => {
    setDontScroll && setDontScroll(true)
    setConversationList && setConversationList(prev => prev?.map(each => each?.id === id ? {
      ...each, prompt: { ...each?.prompt, apiCheck: e?.target?.checked }
    } : each))
  }

  // use Effects
  useEffect(() => {
    if (!dontScroll) {
      bottomRef?.current &&
      bottomRef?.current?.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "start",
      });
    }
  }, [conversationList]);

  // set moment calender to display day in perticular formats
  moment.locale("en", {
    calendar: {
      lastDay: "[Yesterday]",
      sameDay: "LT",
      lastWeek: "dddd",
      sameElse: "L LT",
    },
  });

  const [recomendations, setRecomendations] = useState(false)

  const displayChatData = useCallback(
    () =>
      conversationList && conversationList?.length > 0 ? (
        conversationList?.map((each) => (
          <div className="conversation-list" key={each?.id}>
            {each?.prompt ? (
              <div className="conversation-container prompt">
                { displayCheck ?<> { [ProjectStatus.DRAFT, ProjectStatus.WORK_SPACE].includes(project_main?.project_status as ProjectStatus) ? <div className="check-main">
                  {each?.prompt?.apiCheck ? <></> : <span className="check-label">API</span>}
                  <input 
                    type="checkbox" name="api-check" id={`${each?.id}-check`} className="api-check" 
                    checked={each?.prompt?.apiCheck}
                    onChange={e => handleApiCheck(e, each?.id)}
                  />
                </div> :""}</>: <></>}
                <div className="conversation prompt">
                  {displayCheck && each?.prompt?.apiCheck ? <span className="api-text">API</span> : <></>}
                  <div className={`text ${each?.prompt?.apiCheck ? 'checked' : ''}`}>{each?.prompt?.value}</div>
                  <div>
                    {!!each?.image && (
                    <div>
                    <img
                        src={each?.image}
                        alt="Cropped Preview"
                        style={{
                        border: "0.5px solid rgb(75, 190, 243)",
                        marginTop:'10px',
                        padding:'5px',
                        objectFit: "contain",
                        borderRadius: '5px',
                        width: '150px',
                        height: '100px',
                        cursor:'pointer',
                        }}
                        onClick={()=>{promptImageView(each?.image)}}
                    />
                    </div>
                )}
                  </div>
                  <div className="time">
                    {each?.prompt?.time ? (
                      moment(each?.prompt?.time).calendar()
                    ) : (
                      <></>
                    )}
                  </div>
                </div>
              </div>
            ) : (
              <></>
            )}
            {each?.answer ? (
              <div className="conversation-container answer">
                <img src={ChatIcon} alt="ChatIcon" className="chat-icon" />
                <div className="conversation answer">
                  <div className="text">
                    {typeof each?.answer?.value === "string" ||
                    typeof each?.answer?.value === "number"
                      ? each?.answer?.value
                      : JSON.stringify(each?.answer?.value)}
                  </div>
                  <div className="time">
                    {each?.answer?.time ? (
                      moment(each?.answer?.time).calendar()
                    ) : (
                      <></>
                    )}
                  </div>
                </div>
              </div>
            ) : (
              <></>
            )}
          </div>
        ))
      ) : (
        <div className="not-found">
          {notFoundMessage || ( [ProjectStatus.DRAFT, ProjectStatus.WORK_SPACE].includes(project_main?.project_status as ProjectStatus) && "No conversations found")}
        </div>
      ),
    [conversationList]
  );

  return (
    <div className="chat-component">
      <div className="chat-display-container">
        {displayChatData()}
        <div ref={bottomRef} />
      </div>
      {chatLoader ? (
        <div className="loader-box">
          <ChatLoader />
        </div>
      ) : (
        // <img src={TypingIcon} alt="TypingIcon" className="typing-icon" />
        <></>
      )}
      {LoaderHOC(
        <>
        {project_main?.project_status === ProjectStatus.PRODUCTION ? 
        <div onClick={()=>setRecomendations(false)}>
        <ProductionQuestionsList
          questionsList={questionsList}
          onQuestionClick={question_answer}
        /> </div>: 
        <>
        {recomendations &&
        <div onClick={()=>setRecomendations(false)}>
        <QuestionsList
        questionsList={questionsList}
        onQuestionClick={question_answer}
      /> </div>}
      </>}
        </>,
        LOADER_ENUM.QUESTIONS_LIST
      )}
      {!!props?.croppedImage && (
        <div className="chat-image-container">
          <div className="clear-cropped" onClick={()=>props?.clearImage && props?.clearImage()}>x</div>
          <img
            src={props?.croppedImage}
            alt="Cropped Preview"
            style={{
              border: "1px solid rgb(160 210 222)",
              objectFit: "contain",
              width: '100%',
              height: '100px',
              margin: '0px 15px 5px 15px',
            }}
          />
        </div>
      )}
      <div className="chat-text-area">
        <textarea
          name="chat-text-area-input"
          id="chat-text-area-input"
          value={chatText}
          onChange={handleChatTextChange}
          placeholder="Type your question here"
          disabled={textAreaDisable}
          onKeyDown={keyDownCheck}
        />
        <div className="option-buttons">
        {props?.isAddOptions ? <button
          // onClick={() => {
          //   setRecomendations((prev) => !prev)
          // }}
          // disabled={questionsList?.length<=0}
        >
          <img src={add} alt="SendIcon" className="" />
        </button> : <div></div>}
        <div>
        {props?.isRecomendationsOptions ? <button
          onClick={() => {
            setRecomendations((prev) => !prev)
          }}
          disabled={questionsList?.length<=0}
        >
          <img src={themeName === ThemeTypes?.BLUE_THEME ? bulbDark : bulbIcon} className="blubset" alt="SendIcon" />
        </button> : null}
        <button
          onClick={() => {
            question_answer(chatText);
            setChatText("");
          }}
          disabled={!chatText || textAreaDisable}
        >
          <img src={SendIcon} alt="SendIcon" className="" />
        </button>
        </div>
        </div>
      </div>
      <Modal
          className="project-modal extracted-settings"
          isOpen={imageModal}
          fade={false}
          toggle={toggleImageModal}
        >
          <ModalHeader toggle={toggleImageModal}>Cropped Image</ModalHeader>
          <ModalBody>
          <img
            src={popImage}
            alt="Cropped Preview"
            style={{
            marginTop:'10px',
            padding:'5px',
            objectFit: "contain",
            borderRadius: '5px',
            width: '100%',
            height: '100%',
            cursor:'pointer',
            }}
            onClick={()=>{toggleImageModal()}}
                    />
          </ModalBody>
        </Modal>
      {/* { summarization?.enableSummarization ? 
        <Button className='chat-summarize-btn' onClick={
          () => 
            summarization?.knowledgebase_summarization && 
            summarization?.knowledgebase_summarization()
          }
        >
          Summarize
        </Button> : <></>} */}
    </div>
  );
};

export default ChatComponent2;
